




























import { defineComponent } from "@vue/composition-api";
import BasePicture from "@/components/Base/BasePicture";
import LandingCreatorsButton from "./LandingCreatorsButton.vue";

export default defineComponent({
  name: "LandingCreatorsSuccessStories",
  components: { BasePicture, LandingCreatorsButton },
  setup() {
    const models = [
      {
        name: "Laura",
        image: "img/landingCreators/models/laura",
      },
      {
        name: "Patricia",
        image: "img/landingCreators/models/patricia",
      },
      {
        name: "Carmen",
        image: "img/landingCreators/models/carmen",
      },
      {
        name: "Lucia",
        image: "img/landingCreators/models/lucia",
      },
      {
        name: "Maria",
        image: "img/landingCreators/models/maria",
      },
      {
        name: "Jena",
        image: "img/landingCreators/models/jena",
      },
      {
        name: "Cristina",
        image: "img/landingCreators/models/cristina",
      },
      {
        name: "Natalia",
        image: "img/landingCreators/models/natalia",
      },
    ];

    return {
      models,
    };
  },
});
